import { render } from "./CallPage.vue?vue&type=template&id=64084409&ts=true"
import script from "./CallPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/call/CallPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64084409"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64084409', __exports__)) {
    api.reload('64084409', __exports__)
  }
  
  module.hot.accept("./CallPage.vue?vue&type=template&id=64084409&ts=true", () => {
    api.rerender('64084409', render)
  })

}


export default __exports__